import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import type { PillarPageContent } from '../types/pillarPage';
type PurposeSectionProps = {
  content: PillarPageContent['purpose'];
};
export function PurposeSection({
  content
}: PurposeSectionProps) {
  return <section className="w-full bg-ink py-28 lg:py-40" data-id="element-240" data-mp="2qgdmi65g62lm">
      <div className="mx-auto w-full max-w-[1240px] px-6 sm:px-10" data-id="element-241" data-mp="2qg3qo1xq1180">
        <Reveal data-id="element-242" data-mp="1sto9705ao3kg">
          <Eyebrow data-id="element-243" data-mp="1su6esnduju51">{content.eyebrow}</Eyebrow>
          <h2 className="mt-6 max-w-xl text-3xl font-extrabold leading-[1.1] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3rem]" data-id="element-244" data-mp="1xry9tq9sfwdg">
            {content.title}
          </h2>
        </Reveal>

        <ul className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-accent-deep/60 bg-accent-deep/40 sm:grid-cols-2 lg:grid-cols-4" data-id="element-245" data-mp="26so0kfk6ywkb">
          {content.reasons.map((reason, i) => <Reveal as="li" key={reason.label} delay={0.05 * i} className="h-full" data-id="element-246" data-mp="3i7jfm2mr301e" data-mpi={i}>
              <div className="flex h-full flex-col bg-surface p-8 transition-colors duration-200 ease-elite hover:bg-surface-2 lg:p-9" data-id="element-247" data-mp="3ol2wjoq8vbc5">
                <span className="text-[11px] font-bold uppercase tracking-label text-accent" data-id="element-248" data-mp="3jlq7qyftbu6x">
                  {reason.label}
                </span>
                <p className="mt-5 text-[15px] leading-relaxed text-ash" data-id="element-249" data-mp="3eozsgdbu12mk">{reason.text}</p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-250" data-mp="35na3rf9c4hsh">
          <p className="mx-auto mt-24 max-w-4xl text-center text-2xl font-extrabold leading-[1.15] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3.2rem]" data-id="element-251" data-mp="35njmchs1vmo5">
            {content.statementLead}{' '}
            <span className="text-accent" data-id="element-252" data-mp="2vwp0heipup38">{content.statementAccent}</span>
          </p>
        </Reveal>
      </div>
    </section>;
}